import { post, get, put, patch, remove } from "../../ApiService";
import { ApiUrl } from "../../ApiUrl";
import {
  GetVehicleListParams,
  VehicleEmissionType,
  VehicleMasterRequest,
  VehicleMasterType,
  VehicleType,
} from "./types";

export const getVehicleEmissionList = async (
  params: GetVehicleListParams,
  region: number,
  project: any,
  site: any
) => {
  try {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append("page", params.page.toString());
    if (params.pageSize)
      queryParams.append("pageSize", params.pageSize.toString());
    if (params.orderBy)
      queryParams.append("order_by", params.orderBy.toString());
    if (params.search) queryParams.append("search", params.search);
    if (site) queryParams.append("site", site);

    const queryString = queryParams.toString();
    const url = `${ApiUrl.vehicleModule.vehicleEmission}${
      queryString ? `?${queryString}` : ""
    }&region=${region}&project=${project}&site=${site}`;

    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getVehicleMasterList = async (region: number, project: any, site: number) => {
  try {
    const url = `${ApiUrl.vehicleModule.vehicleMasterData}?region=${region}&project=${project}&site=${site}`;
        const res = await get(url);
         return res.data;
  } catch (error: any) {
    return error.response;
  }
};

export const copyvehicleMaster =async(data:any, region:number)=>{
  try{
    const url =`${ApiUrl.vehicleModule.VehicleMasterCopy}?region=${region}`
    const res = await post(url,data);
    return res;
  }catch(error:any){
    return error.response;
  }
}




export const getVehicleEmissionById = async (id: number, project: any) => {
  try {
    const url = `${ApiUrl.vehicleModule.vehicleEmissionById(
      id
    )}?project=${project}`;
    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const createVehicleEmission = async (
  data: VehicleEmissionType,
  region: number,
  project: any,
  site: any
) => {
  try {
    const url = `${ApiUrl.vehicleModule.vehicleEmission}?region=${region}&project=${project}&site=${site}`;
    const res = await post(url, data);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const updateVehicleEmission = async (
  id: number,
  data: VehicleEmissionType,
  region: number,
  project: any
) => {
  try {
    const url = `${ApiUrl.vehicleModule.vehicleEmissionById(
      id
    )}?region=${region}&project=${project}`;
    const res = await put(url, data);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const deleteVehicleEmission = async (
  id: number,
  region: number,
  project: any
) => {
  try {
    const url = `${ApiUrl.vehicleModule.vehicleEmissionById(
      id
    )}?region=${region}&project=${project}`;
    const res = await remove(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const approveEmission = async (
  id: number,
  region: number,
  project: any
) => {
  try {
    const url = `${ApiUrl.vehicleModule.approveEmission}?region=${region}&project=${project}&id=${id}`;
    const res = await post(url, { id });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const rejectEmission = async (
  id: number,
  region: number,
  project: any
) => {
  try {
    const url = `${ApiUrl.vehicleModule.rejectEmission}?region=${region}&project=${project}&id=${id}`;
    const res = await post(url, { id });
    return res;
  } catch (error: any) {
    return error.response;
  }
};